import * as React from "react";
import { Avatar as PrimeAvatar } from "primereact/avatar";
import { cn } from "@/lib/utils";

const Avatar = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("p-avatar-circle", className)} {...props} />
  )
);
Avatar.displayName = "Avatar";

interface AvatarImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {}

const AvatarImage = React.forwardRef<HTMLImageElement, AvatarImageProps>(
  ({ className, src, alt, ...props }, ref) => {
    const imageSrc = typeof src === "string" ? src : undefined;
    
    return (
      <PrimeAvatar
        image={imageSrc}
        imageAlt={alt}
        shape="circle"
        className={cn(className)}
        {...props}
      />
    );
  }
);
AvatarImage.displayName = "AvatarImage";

interface AvatarFallbackProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const AvatarFallback = React.forwardRef<HTMLDivElement, AvatarFallbackProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <PrimeAvatar
        label={typeof children === "string" ? children : undefined}
        shape="circle"
        className={cn(className)}
        {...props}
      >
        {typeof children !== "string" ? children : undefined}
      </PrimeAvatar>
    );
  }
);
AvatarFallback.displayName = "AvatarFallback";

export { Avatar, AvatarImage, AvatarFallback };
